import Vue from 'vue';

const highlight = {
    install(Vue, options) {
        Vue.directive('highlight', this);
    },
    componentUpdated(el, binding) {
        if (binding.value != binding.oldValue) {
            el.style.backgroundColor = '#ff9';
            el.style.transition = 'background 0s';

            requestAnimationFrame(() => {
                el.style.backgroundColor = null;
                el.style.transition = 'background 0.6s';
            });
        }
    },
};

export default highlight;
